export interface UserData {
  _id: string;
  username: string;
  email: string;
  firstName?: string;
  lastName?: string;
  impersonate?: UserData;
}

export interface UserAccessData {
  globalRoles: string[];
  accessRoles: [string, string[]][];
}

export interface UserSession {
  access_token: string;
  refresh_token?: string;
  expires_at: number;
  userData: UserData;
  userAccessData: UserAccessData;
  tncApproved?: boolean;
  exchange_token?: string;
}
